/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosText } from "@components/elements/atoms";
import { DocumentListFragment, DocumentListItemFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { DocumentListItem } from "./DocumentListItem.atom";

const styles = css({
	maxWidth: "cosmos.article.sm",
	w: "full",

	"& .document-list-item:first-child": {
		borderTopRadius: "eds.borderRadius.16",
	},

	"& .document-list-item:last-child": {
		borderBottomRadius: "eds.borderRadius.16",
	},
});

export interface DocumentListProps extends DocumentListFragment {
	className?: string | null;
}

const sortFn = (a?: DocumentListItemFragment, b?: DocumentListItemFragment): number => {
	const aTitle = a?.title || "";
	const bTitle = b?.title || "";
	return aTitle.localeCompare(bTitle);
};

export const DocumentList = (props: DocumentListProps): React.JSX.Element => {
	const items = (props?.items || []).sort(sortFn);

	return (
		<div className={cx("document-list", styles, props.className)}>
			<VStack alignItems="flex-start" gap="eds.dimension.24">
				{props.heading ? <CosmosText variant="headingLG">{props.heading}</CosmosText> : null}
				<VStack className={cx("items", css({ w: "full" }))} gap="eds.dimension.2">
					{items.map((item) => {
						return <DocumentListItem key={item.title} {...item} />;
					})}
				</VStack>
			</VStack>
		</div>
	);
};
